import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER, IS_BIZ_USER, IS_ONPREMISE, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';

/**
 * CLOUD-4585: Фича для вкл/выкл welcome модалки
 */
export const familyTariffOnboardingModal = isFeature('family-tariff-onboarding-modal');

/**
 * CLOUD-4600: Фича переключения на просмотр паблика членам семьи
 */
export const familyAlmbumPublicLink = isFeature('family-album-public-link');

export const promoQuotaFamilyTariffCreateFamily = getFeature('promo-quota-family-tariff-create-family') || [];

export const familyFeaturePreviewPaid =
    isFeature('family-feature-preview-paid') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER && IS_PAID_USER;
export const familyFeaturePreviewFree =
    isFeature('family-feature-preview-free') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER && !IS_PAID_USER;

export const familyFeaturePreview = familyFeaturePreviewPaid || familyFeaturePreviewFree;

export const familyFeaturePreviewProduct = getFeature('family_features_preview_product') || 'W1TB_1y_family_features_a';

export const familyFeaturePreviewFreeAsideTooltip = familyFeaturePreviewFree && isFeature('family-feature-preview-free-aside-tooltip');
export const familyFeaturePreviewPaidAsideTooltip = familyFeaturePreviewPaid && isFeature('family-feature-preview-paid-aside-tooltip');
export const familyFeaturePreviewAsideTooltip = familyFeaturePreviewFreeAsideTooltip || familyFeaturePreviewPaidAsideTooltip;

export const familyFeaturePreviewFreeAlbumsTooltip = familyFeaturePreviewFree && isFeature('family-feature-preview-free-albums-tooltip');
export const familyRouteTextDisabled = isFeature('family-route-text-disabled');
export const familyRouteTariffId = getFeature('family-route-tariff-id') || 'W1TB_1y_family_landing_exp_force_trial';

export const familyFeaturePreviewPaidAlbumsTooltip = familyFeaturePreviewPaid && isFeature('family-feature-preview-paid-albums-tooltip');
export const familyFeaturePreviewAlbumsTooltip = familyFeaturePreviewFreeAlbumsTooltip || familyFeaturePreviewPaidAlbumsTooltip;

export const familyFeatureDropdownPreviewFree =
    isFeature('family-feature-dropdown-preview-free') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER;
export const familyFeatureDropdownPreviewPaid =
    isFeature('family-feature-dropdown-preview-paid') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER;

export const familyFeatureDropdownButtons = isFeature('family-feature-dropdown-buttons');
